import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const closeWrapper = style({
  position: 'absolute',
  top: 0,
  right: 0,
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'all 0.2s',
  zIndex: 10,
  borderTopRightRadius: vars.blocks.largeRadius,
  borderBottomLeftRadius: vars.blocks.radius,
  color: vars.color.dark,
  fontWeight: 900,
  fontSize: 18,

  ':hover': {
    backgroundColor: vars.color.drawBackgroundLighter,
    color: vars.color.darkLighter
  }
})
